/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pin': {
    width: 29,
    height: 29,
    viewBox: '0 0 29 29',
    data: '<path d="M14.7452 27.4281V24.7484V20.059V14.5522M14.7452 14.5522C14.058 14.5569 13.3766 14.4255 12.7404 14.1657C12.1042 13.9059 11.5256 13.5228 11.0381 13.0385C10.5505 12.5542 10.1636 11.9782 9.89951 11.3438C9.63546 10.7093 9.49952 10.0289 9.49952 9.34163C9.49952 8.65441 9.63546 7.97398 9.89951 7.33951C10.1636 6.70504 10.5505 6.12907 11.0381 5.64476C11.5256 5.16046 12.1042 4.77738 12.7404 4.51758C13.3766 4.25779 14.058 4.12641 14.7452 4.13101C16.1112 4.15476 17.4134 4.7141 18.371 5.68857C19.3287 6.66304 19.8653 7.97467 19.8653 9.34096C19.8653 10.7072 19.3287 12.0189 18.371 12.9933C17.4134 13.9678 16.1112 14.5272 14.7452 14.5509V14.5522Z" stroke="#768692" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
